// extracted by mini-css-extract-plugin
module.exports = {"swatch-group":"SwatchGroup_swatch-group__CwnQo"};